import _ from "lodash";
import ActionTypeCliente from "../ActionTypeCliente";
import Contacto from "../../Contacto";

export default class EliminarContacto extends ActionTypeCliente {
    
    ejecutar(estado, nuevoEstado) {
        //El indexSeleccionado nunca puede ser el contacto por definir "Definir Nuevo"
        const indexSeleccionadoAEliminar = estado.domain.screen.contactos.indexSeleccionado;
        const indexDeContactoSucesor = indexSeleccionadoAEliminar+1
        
        const ultimoIndiceListaNombres = estado.domain.screen.contactos.listaNombres.length-1;
        let contactoSucesor = null;
        if (indexDeContactoSucesor === ultimoIndiceListaNombres) {
            contactoSucesor = estado.domain.screen.contactos.contactoPorDefinir;
        }else{
            contactoSucesor = estado.domain.screen.contactos.data[indexDeContactoSucesor];
        }
        
        const atributos = nuevoEstado.domain.screen.contactos.atributos;
        atributos.nombre    = contactoSucesor.nombre;
        atributos.rol       = contactoSucesor.rol;
        atributos.telcel1   = contactoSucesor.telcel1;
        atributos.telcel2   = contactoSucesor.telcel2;
        atributos.telfijo   = contactoSucesor.telfijo;
        atributos.email     = contactoSucesor.email;
        
        const valorDeListaSucesor = estado.domain.screen.contactos.listaNombres[indexDeContactoSucesor];
        nuevoEstado.domain.screen.contactos.valorListaNombres={sec: valorDeListaSucesor.sec, nombre: valorDeListaSucesor.nombre};
        nuevoEstado.domain.screen.contactos.listaNombres.splice(indexSeleccionadoAEliminar, 1);
        nuevoEstado.domain.screen.contactos.data.splice(indexSeleccionadoAEliminar, 1);

        return nuevoEstado;

        /* if (valorSelec.nombre === "Definir Nuevo") {
            //console.log("Definir nuevo yaya");
            return {
                ...state,
                personasContacto: {
                    ...state.personasContacto,
                    valorListaNombres: valorSelec,
                    atributos: {
                        nombre: "Definir Nuevo",
                        rol: "",
                        telcel1: "",
                        telcel2: "",
                        telfijo: "",
                        email: "",
                    },
                },
            };
        }

        // console.log("buscar contacto: ");

        //Seleccionar el contacto seleccionado
        const contactoSelec = state.personasContacto.contactosAct.find((contacto) => {
            return contacto.nombre === valorSelec.nombre ? true : false;
        });

        // console.log("contacto selec: ", contactoSelec);

        return {
            ...state,
            personasContacto: {
                ...state.personasContacto,
                valorListaNombres: valorSelec,
                atributos: {
                    nombre: contactoSelec.nombre,
                    rol: contactoSelec.rol,
                    telcel1: contactoSelec.telcel1,
                    telcel2: contactoSelec.telcel2,
                    telfijo: contactoSelec.telfijo,
                    email: contactoSelec.email,
                },
            },
        }; */






        
    }
}
